import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './buy-product.component'

import CountryOfResidence        from './country-of-residence'
import PaymentWorldpay           from './payment-worldpay'
import PaymentSips               from './payment-sips'

let module = angular.module('buyProduct', [
  uiRouter,
  CountryOfResidence,
  PaymentWorldpay,
  PaymentSips
])

.component('buyProduct', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/my-purchase/buy-product/index.js